import { InputState } from '@kubit/web-ui-components/input/types';
export const commonStateStyles = (FOUNDATIONS, FONT) => ({
    [InputState.EMPTY]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.FILLED]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.ACTIVE]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.DISABLED_EMPTY]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.DISABLED_FILLED]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.DISABLED_FILLED_WITH_INFO]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.ERROR_EMPTY]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.ERROR_FILLED]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.ERROR_ACTIVE]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
    [InputState.ERROR_FILLED_WITH_INFO]: { ...commonReadOnlyStyles(FOUNDATIONS, FONT) },
});
const commonReadOnlyStyles = (FOUNDATIONS, FONT) => ({
    inputContainer: {
        readOnly: {
            cursor: 'pointer',
        },
    },
    //TODO: Fix temporal meanwhile we do InputActionV2
    paddingLeftForLeftIcon: '2.75rem',
});
//# sourceMappingURL=commonStyles.js.map